module.exports = __webpack_public_path__ + "img/badge-fifty.5abb5ef.jpg";